import { cn } from '@/utils/cn';

interface Pair {
  home_team: number;
  away_team: number;
}

const order = (pair: Pair, swapped: boolean) =>
  swapped ? [pair.away_team, pair.home_team] : [pair.home_team, pair.away_team];

export const SetTally = ({
  sets,
  currentSet,
  setsWon,
  swapped,
  variant,
}: {
  sets: Pair[];
  currentSet?: Pair;
  setsWon: Pair;
  swapped: boolean;
  variant: 'display' | 'overlay';
}) => {
  const [leftWon, rightWon] = order(setsWon, swapped);
  const [leftNow, rightNow] = currentSet ? order(currentSet, swapped) : [];
  const big = variant === 'display' ? 'text-[30vh]' : 'text-5xl';
  const mid = variant === 'display' ? 'text-[15vh]' : 'text-2xl';
  const small =
    variant === 'display'
      ? 'text-[5vh] text-slate-500'
      : 'text-sm text-slate-500';

  return (
    <div className="flex flex-col items-center leading-none">
      <div className={cn('flex gap-[4vw] font-bold', big)}>
        <span>{leftWon}</span>
        <span>{rightWon}</span>
      </div>
      {variant === 'display' &&
        sets.map((set, index) => {
          const [left, right] = order(set, swapped);

          return (
            <div key={index} className={cn('flex gap-[4vw]', small)}>
              <span>{left}</span>
              <span>{right}</span>
            </div>
          );
        })}
      {currentSet && (
        <div className={cn('flex gap-[4vw] font-medium', mid)}>
          <span>{leftNow}</span>
          <span>{rightNow}</span>
        </div>
      )}
    </div>
  );
};
